import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { DisplayModule } from './../../display';
import { CbDataTableModule } from './../../cb-data-table';

import { OfferListComponent } from './offer-list.component';

@NgModule({
  declarations: [
    OfferListComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    NgbModule,
    RouterModule,
    DisplayModule,
    CbDataTableModule
  ],
  exports: [
    OfferListComponent
  ]
})
export class OfferListModule {
  constructor() {

  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+offer/offer-list/offer-list.module.ts